<ng-container [ngSwitch]="errorCode">
  <mat-card class="errorCard" *ngSwitchCase="httpStatusCode.HTTP_GONE">
    <h1>{{'ERROR.EXPIRED_TITLE' | translate}}</h1>
    <p>{{'ERROR.EXPIRED_TEXT' | translate}}</p>
  </mat-card>

  <mat-card class="errorCard" *ngSwitchCase="httpStatusCode.HTTP_NO_CONTENT">
    <h1>{{'ERROR.PROCESSED_TITLE' | translate}}</h1>
    <p>{{'ERROR.PROCESSED_TEXT' | translate}}</p>
  </mat-card>

  <mat-card class="errorCard" *ngSwitchCase="httpStatusCode.HTTP_NOT_FOUND">
    <h1>{{'ERROR.NOT_FOUND_TITLE' | translate}}</h1>
    <p>{{'ERROR.NOT_FOUND_TEXT' | translate}}</p>
  </mat-card>

  <mat-card class="errorCard" *ngSwitchCase="httpStatusCode.HTTP_BAD_REQUEST">
    <h1>{{'ERROR.BAD_REQUEST_TITLE' | translate}}</h1>
    <p>{{'ERROR.BAD_REQUEST_TEXT' | translate}}</p>
  </mat-card>
</ng-container>